import React, { useEffect, useState } from "react";
import "./Admin.css";
import Navbar from "../MainComponent/navbar";
import SideNav from "../MainComponent/sideNav";
import AdminDesignerInfo from "./AdminDesignerInfo";
import AdminProjectInfo from "./AdminProjectInfo";
import { resetQuantityInfo } from "../../../Features/quantityInfo";
import { resetRoofInfo } from "../../../Features/roofInfo";
import Loader from "../MainComponent/loader";

export default function Admin() {
  const [loader] = useState(true);
  const [designerList, setDesignerList] = useState([]);
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    resetQuantityInfo();
    resetRoofInfo();
    // eslint-disable-next-line
  }, []);

  return loader ? (
    <Loader></Loader>
  ) : (
    <div className="adminContainer">
      <Navbar></Navbar>
      <SideNav active="admin" />
      <div className="adminContent">
        <p className="headline">Admin</p>
        <AdminDesignerInfo
          designerList={designerList}
          setDesignerList={setDesignerList}
        />
        <AdminProjectInfo
          projectList={projectList}
          setProjectList={setProjectList}
        />
      </div>
    </div>
  );
}
